export default "__VITE_ASSET__2f605144__"